import React, { useEffect, useState, useRef } from "react";
import Classes from "./styles/style.module.css";
import QRCode from "react-fancy-qrcode";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import { useParams } from "react-router";
import { useLocation, useNavigate } from "react-router-dom";
import CustomHint from "../../assets/containers/CustomHint";
import FooladLogo from "../../assets/images/icons/fooladLogo.svg";
import Hint from "../../assets/components/Hint";
import CustomButton from "../../assets/components/CustomButton";
import appApi from "../../assets/utils/AppApi";
import errorHandler from "../../assets/utils/ErrorHandler";
import Loading from "../../assets/containers/loadingDialog";
import toast from "react-hot-toast";

const FormQR = () => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const showMessage = location.state?.showMessage;
  const [loading, setLoading] = useState(false);
  const [ticket, setTicket] = useState();
  const [displayRemoveButton, setDisplayRemoveButton] = useState(false);
  const [removing, setRemoving] = useState(false);

  const qrContainerRef = useRef(null);
  const [qrSize, setQrSize] = useState(0);

  const updateQrSize = () => {
    if (qrContainerRef.current) {
      setQrSize(qrContainerRef.current.clientWidth - 36);
    }
  };

  const checkTicket = async () => {
    setLoading(true);
    try {
      await appApi
        .post(`/formfilled/attend/getsingle/${params.id}`)
        .then(({ data }) => {
          setTicket(data.formfilledUpdated);
          setLoading(false);
        });
    } catch (error) {
      errorHandler(error);
      setLoading(false);
    }
  };

  const checkDisplayRemoveButton = async (formFilledId) => {
    if (!formFilledId) {
      setDisplayRemoveButton(false);
      return;
    }

    try {
      const { data } = await appApi.get(
        `/formfilled/remove/displayremovebutton/user/${formFilledId}`
      );
      setDisplayRemoveButton(data?.displayRemoveButton === true);
    } catch (_error) {
      setDisplayRemoveButton(false);
    }
  };

  const handleRemoveFormFilled = async () => {
    if (removing) return;

    const shouldRemove = window.confirm("آیا از حذف ورودی اطمینان دارید؟");
    if (!shouldRemove) return;

    setRemoving(true);
    try {
      await appApi.delete(`/formfilled/remove/${params.id}`);
      toast.success("ورودی با موفقیت حذف شد");
      navigate("/forms", { replace: true });
    } catch (error) {
      errorHandler(error);
    } finally {
      setRemoving(false);
    }
  };

  useEffect(() => {
    checkTicket();
  }, []);

  useEffect(() => {
    checkDisplayRemoveButton(params.id);
  }, [params.id]);

  useEffect(() => {
    if (ticket) {
      updateQrSize();
      window.addEventListener("resize", updateQrSize);
      return () => window.removeEventListener("resize", updateQrSize);
    }
  }, [ticket]);

  return (
    <AnimatedPageContainer>
      <div className={"customContainer"}>
        {loading ? (
          <div className="w-100 d-flex justify-content-center py-5 my-5">
            <Loading size={30} />
          </div>
        ) : (
          ticket && (
            <>
              {showMessage ? (
                <div className="my-3">
                  <Hint
                    hintText={
                      ticket?.form?.confirmationMessage
                        ?.customFormMessageEnabled
                        ? ticket?.form?.confirmationMessage?.customFormMessage
                        : "فرم با موفقیت ثبت شد"
                    }
                  />
                </div>
              ) : (
                <>
                  <div className="w-100 my-3">
                    <>
                      <Hint
                        hintText={
                          ticket?.form?.confirmationMessage
                            ?.customFormMessageEnabled
                            ? ticket?.form?.confirmationMessage
                                ?.customFormMessage
                            : "فرم با موفقیت ثبت شد"
                        }
                      />
                      <CustomHint
                        hint={
                          "از صفحه‌ی خود تصویری تهیه نموده وهنگام مراجعه به متصدی ارائه نمایید."
                        }
                      />
                    </>
                  </div>
                  <div className={Classes.qrContainer} ref={qrContainerRef}>
                    <QRCode
                      logo={FooladLogo}
                      removeQrCodeBehindLogo
                      value={JSON.stringify({
                        _id: params.id,
                        type: "Form",
                      })}
                      dotScale={0.8}
                      dotRadius="50%"
                      positionRadius={["5%", "1%"]}
                      size={qrSize}
                      errorCorrection="H"
                    />
                    <p className="text-center mt-3 mb-0">{ticket.form.title}</p>
                  </div>
                </>
              )}

              <div className={Classes.tecketDetailsContainer}>
                <div>
                  <p>کد رهگیری :</p>
                  <p>{params.id}</p>
                </div>
                <hr />
                <div>
                  <p style={{ marginBottom: "0" }}>نام و نام خانوادگی :</p>
                  <p style={{ marginBottom: "0" }}>{ticket.owner.fullName}</p>
                </div>
                <hr />
                <div>
                  <p style={{ marginBottom: "0" }}>کد ملی:</p>
                  <p style={{ marginBottom: "0" }}>
                    {ticket.owner.nationalCode}
                  </p>
                </div>
                <hr />
                <div>
                  <p style={{ marginBottom: "0" }}>کد پرسنلی:</p>
                  <p style={{ marginBottom: "0" }}>
                    {ticket.owner.personnelCode}
                  </p>
                </div>
                <hr />
                <div>
                  <p style={{ marginBottom: "0" }}>نام رویداد:</p>
                  <p style={{ marginBottom: "0" }}>{ticket.form.title}</p>
                </div>
                {ticket.form.type !== "Exam" && (
                  <>
                    <hr />
                    <div>
                      <p
                        style={{
                          marginBottom: "0",
                          width: "100%",
                          textAlign: "center",
                        }}
                      >
                        ورودی های کاربر:
                      </p>
                    </div>
                    {ticket.fields.map((item) => {
                      if (!item.userInput) return null;

                      const urlPattern = /(https?:\/\/[^\s]+\/([^\s\/]+))$/;
                      const match = item.userInput.match(urlPattern);

                      return (
                        <React.Fragment key={item._id}>
                          <hr />
                          <div>
                            <p style={{ marginBottom: "0" }}>{item.title}</p>
                            <p style={{ marginBottom: "0" }}>
                              {match ? (
                                <a
                                  href={match[1]}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    color: "var(--secondary500)",
                                    textDecoration: "underline",
                                  }}
                                >
                                  {match[2]}
                                </a>
                              ) : (
                                item.userInput
                              )}
                            </p>
                          </div>
                        </React.Fragment>
                      );
                    })}
                  </>
                )}
              </div>

              {displayRemoveButton && (
                <div className="mt-3">
                  <CustomButton
                    clickHandler={handleRemoveFormFilled}
                    text={
                      removing
                        ? "در حال حذف..."
                        : "حذف " +
                          (ticket.form.type === "Signup"
                            ? "ثبت نام"
                            : "پاسخ ها")
                    }
                    styles={{
                      backgroundColor: "#dc3545",
                      color: "#ffffff",
                      border: "1px solid #dc3545",
                      opacity: removing ? 0.7 : 1,
                      pointerEvents: removing ? "none" : "auto",
                    }}
                  />
                </div>
              )}
            </>
          )
        )}
      </div>
    </AnimatedPageContainer>
  );
};

export default FormQR;
